import { createDefaultContext } from "@imi/ui/helpers/createDefaultContext.js";
import { createContext } from "react";
import { EngineWorkerClient } from "../client/createEngineWorkerClient";

export type EngineWorkerContextType = {
  error: Error | null;
  loading: boolean;
  request: EngineWorkerClient["request"];
  waitUntilReady: () => Promise<void>;
};

export const EngineWorkerContext = createContext<EngineWorkerContextType>(
  createDefaultContext(),
);
